import { Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React, { useMemo } from 'react';
const AuthenticationLayout = ({ children }) => {
    const currentYear = useMemo(() => {
        return moment().format('YYYY');
    }, []);
    return (React.createElement(Stack, { direction: 'row', sx: {
            height: '100vh',
            img: {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            },
        } },
        React.createElement(Stack, { direction: 'column', justifyContent: 'space-between', sx: {
                width: '100%',
                height: '100%',
                maxWidth: '480px',
                bgcolor: 'background.paper',
            } },
            React.createElement(Stack, { direction: 'column', sx: {
                    width: '100%',
                    maxWidth: '400px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    paddingTop: '40px',
                    paddingBottom: '28px',
                    '.MuiTypography-h4': {},
                    img: {
                        width: '36px',
                        height: '40px',
                    },
                } },
                React.createElement(Image, { name: 'logo.svg', alt: 'logo' }),
                React.createElement(Typography, { variant: 'h4' }, "PROTRACKS")),
            React.createElement(Stack, { direction: 'column', justifyContent: 'center', sx: {
                    width: '100%',
                    maxWidth: '400px',
                    height: '100%',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                } }, children),
            React.createElement(Typography, { variant: 'body1', sx: {
                    paddingTop: '28px',
                    paddingBottom: '40px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    width: '100%',
                    maxWidth: '400px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                } },
                "\u00A9 ",
                currentYear,
                " Digital Technologies, Inc.")),
        React.createElement(Stack, { direction: 'row' },
            React.createElement(Image, { name: 'authentication-layout.jpg', alt: 'authentication-layout' }))));
};
export default AuthenticationLayout;
